import { render, staticRenderFns } from "./PlanningAddDestinationView.vue?vue&type=template&id=cb90404e"
import script from "./PlanningAddDestinationView.vue?vue&type=script&lang=ts"
export * from "./PlanningAddDestinationView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports